import React, { useState, useEffect, Fragment } from "react";
import styled, { css } from "styled-components";
import { Icon } from "../index";
import { IKioskNavigations } from "../../../models/KioskNavigations";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { ModalView } from "../../organisms/Modal/Modal";
import { BalanceAccount } from "../../organisms/BalanceAccount/BalanceAccount";
/**
 * Navigation Items Styles
 */
interface OwnProps {
  bgColor?: string;
  isActive?: boolean;
}

const NavigationItemWrapper = styled.li<OwnProps>`
  width: 100%;
  display: flex;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;
  padding: 0 5px;
  height: 50px;
  overflow: hidden;

  ${(p) =>
    p.bgColor
      ? css`
          background-color: ${(theme) =>
            theme.theme[p.bgColor || "Light6"]} !important;
        `
      : "Light6"};
  &:hover {
    background-color: ${(theme: any) => theme.theme.borderColor};
    .navigation-name.not-increase-money {
      color: ${(p) => p.theme.etGreen};
    }
  }
  ${(p) =>
    p.isActive &&
    css`
      background-color: ${(theme: any) => theme.theme.borderColor};
      .navigation-name.not-increase-money,
      .icon-Dashboard-on {
        color: ${(p) => p.theme.etGreen} !important;
      }
    `};
  .navigation-name {
    opacity: 0;
  }
  &.fold {
    .navigation-name {
      display: none;
    }
    justify-content: center;
  }
  &.unfold {
    justify-content: space-between;
    .navigation-name {
      opacity: 1;
    }
  }
  .navigation-name {
    color: ${(theme) => theme.theme.bgText};
    ${(p) =>
      p.bgColor &&
      css`
        color: ${(theme) => theme.theme.white};
      `};
    font-size: 14px;
    margin-inline-start: 10px;
  }
  a {
    width: 100%;
    height: 100%;
  }
`;

const FontIcon = styled.span`
  font-size: 24px;
  color: ${(theme: any) => theme.theme.bgText};
  &.unfold {
    color: ${(theme: any) => theme.theme.bgText};
    &.active {
      color: ${(theme: any) => "red"};
    }
  }
`;
/**
 * Navigation Item Base Interface
 */
interface INavigationItem {
  isActive?: boolean;
  navItem: IKioskNavigations;
  isFold: "fold" | "unfold";
}

/**
 * Link Item Href
 */
const LinkNav = styled.div`
  display: flex;
  white-space: nowrap;
  width: 100%;
  height: 100%;
  align-items: center;
  &.fold {
    justify-content: center;
  }
  &.unfold {
    justify-content: flex-start;
  }
`;
/**
 *
 * @constructor
 */
export const NavigationItem: React.FC<INavigationItem> = ({
  navItem,
  isFold,
}) => {
  const { t } = useTranslation();
  const [showBalanceModal, setShowBalanceModal] = useState(false);
  const location = useLocation();
  const [path, setPath] = useState("/");

  useEffect(() => {
    switch (location.pathname) {
      case "/":
        setPath("/");
        break;
      case "/markets":
        setPath("market");
        break;
      case "/user/portfolio":
        setPath("portfolio");
        break;
      case "/crypto/trade/history":
        setPath("history");
        break;
      case "/setting":
        setPath("setting");
        break;
      case "/referral":
        setPath("referral");
        break;
    }
  }, [location.pathname]);

  return (
    <NavigationItemWrapper
      isActive={navItem.url === location.pathname + location.search}
      bgColor={navItem.specialBgColor}
      className={isFold}
    >
      {navItem.id !== "increasemoney" && (
        <Link to={navItem.url ? navItem.url : "/"}>
          <LinkNav className={isFold}>
            {navItem.id === "dashboard" ? (
              <Fragment>
                {path === "/" ? (
                  <FontIcon
                    className={`icon-Dashboard-on ${
                      navItem.url === location.pathname + location.search ??
                      "active"
                    }`}
                  >
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </FontIcon>
                ) : (
                  <FontIcon className="icon-Dashboard-off"></FontIcon>
                )}
              </Fragment>
            ) : (
              <Icon
                name={navItem.icon}
                width={navItem.width}
                height={navItem.height}
              />
            )}
            <span className="navigation-name not-increase-money">
              {t(navItem.translate)}
            </span>
          </LinkNav>
        </Link>
      )}
      {navItem.id === "increasemoney" && (
        <div onClick={() => setShowBalanceModal(true)}>
          <LinkNav className={isFold}>
            <Icon
              name={navItem.icon}
              width={navItem.width}
              height={navItem.height}
            />
            <span className="navigation-name">{t(navItem.translate)}</span>
          </LinkNav>
        </div>
      )}
      {showBalanceModal && (
        <ModalView
          width={"400px"}
          height="586px"
          show={showBalanceModal}
          handleClose={() => setShowBalanceModal(false)}
        >
          <BalanceAccount
            onBalanceDone={() => setShowBalanceModal(false)}
            isOpen={showBalanceModal}
          />
        </ModalView>
      )}
    </NavigationItemWrapper>
  );
};
